import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditClient from "../../components/clients/FormAddEditClient";

const CreateClient = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/clients");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditClient
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateClient;